export enum SizeA4 {
    WIDTH_A4 = 794,
    HEIGHT_A4 = 1123
}